import { render, staticRenderFns } from "./Neighborhoods.vue?vue&type=template&id=129d47ad&"
import script from "./Neighborhoods.vue?vue&type=script&lang=js&"
export * from "./Neighborhoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports